const types = {
  CHANGE_PROVINCE: 'CHANGE_PROVINCE',
  INIT_CALCULATOR: 'INIT_CALCULATOR',
  INIT_AUTO_CALCULATOR: 'INIT_AUTO_CALCULATOR',
  UPDATE_PAYMENT_FREQUENCY: 'UPDATE_PAYMENT_FREQUENCY',
  UPDATE_TERM: 'UPDATE_TERM',
  UPDATE_AMOUNT: 'UPDATE_AMOUNT',
  UPDATE_AUTO_LOAN_AMOUNT: 'UPDATE_AUTO_LOAN_AMOUNT',
  UPDATE_YEAR: 'UPDATE_YEAR',
  UPDATE_USER_GEOLOCATION_COORDINATES: 'UPDATE_USER_GEOLOCATION_COORDINATES',
  UPDATE_CITY_GEOLOCATION_COORDINATES: 'UPDATE_CITY_GEOLOCATION_COORDINATES',
  UPDATE_CITY_GEOLOCATION_COORDINATES_FOR_EQUAL_COMPARISION:
    'UPDATE_CITY_GEOLOCATION_COORDINATES_FOR_EQUAL_COMPARISION',
  UPDATE_PROVINCE_COORDINATES_FOR_EQUAL_COMPARISION:
    'UPDATE_PROVINCE_COORDINATES_FOR_EQUAL_COMPARISION',
  UPDATE_FIND_A_BRANCH_GEOLOCATION_COORDINATES:
    'UPDATE_FIND_A_BRANCH_GEOLOCATION_COORDINATES',
  UPDATE_FIND_A_BRANCH_GEOLOCATION_COORDINATES_FOR_EQUAL_COMPARISION:
    'UPDATE_FIND_A_BRANCH_GEOLOCATION_COORDINATES_FOR_EQUAL_COMPARISION',
  UPDATE_BRANCH_LOCATION_COORDINATES: 'UPDATE_BRANCH_LOCATION_COORDINATES',
  UPDATE_RADIUS: 'UPDATE_RADIUS',
  RESET_USER_COORDINATES: 'RESET_USER_COORDINATES',
  REQUIRE_DOCS_MODAL: 'REQUIRE_DOCS_MODAL',
  UPDATE_CONTACT_US_MAP_DATA: 'UPDATE_CONTACT_US_MAP_DATA',
  UPDATE_CITY_PAGE_MAP_DATA: 'UPDATE_CITY_PAGE_MAP_DATA',
  UPDATE_FIND_BRANCH_MAP_DATA: 'UPDATE_FIND_BRANCH_MAP_DATA',
  OPEN_LOAN_PRODUCTS_MODAL: 'OPEN_LOAN_PRODUCTS_MODAL',
  IS_LOAN_PRODUCTS_MODAL: 'IS_LOAN_PRODUCTS_MODAL',
  EMAIL_US_MODAL: 'EMAIL_US_MODAL',
  SEARCH_STATUS: 'SEARCH_STATUS',
  MOBILE_MENU_STATUS: 'MOBILE_MENU_STATUS',
  SEARCH_MODAL_STATUS: 'SEARCH_MODAL_STATUS',
  TOGGLE_PAGE_ANIMATION: 'TOGGLE_PAGE_ANIMATION',
  TRIGGER_MARKETING_MODAL: 'TRIGGER_MARKETING_MODAL',
  STORE_PROVINCE: 'STORE_PROVINCE',
  ALLOW_MAP_LOCATION: 'ALLOW_MAP_LOCATION',
  MOBILE_SEARCH_BUTTON_ACTION: 'MOBILE_SEARCH_BUTTON_ACTION',
};

export default types;
